<template>
   <div class="relative bg-purple">
    <!-- Image Section -->
    <img class="w-full h-[80vh] object-cover" src="@/assets/images/about_us.png" alt="Image" />
    
    <!-- Line Below Image -->
    <div class="absolute bottom-0 w-full h-8 bg-purple"></div>
  </div>
</template>

<script>
export default {
    name: 'Slider',
}
</script>

<style scoped></style>
